import React from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import pure from 'recompose/pure';

const LongTextField = ({ record, source, style }) => (
  <span style={{ whiteSpace: 'pre', ...style }}> {get(record, source)} </span>
);

LongTextField.propTypes = {
  addLabel: PropTypes.bool, // eslint-disable-line
  label: PropTypes.string, // eslint-disable-line
  record: PropTypes.object,
};

const PureLongTextField = pure(LongTextField);


PureLongTextField.defaultProps = {
  addLabel: true,
};

export default PureLongTextField;
